<script setup lang="ts">
import {NAVIGATE_HOME} from "~/constants/navigation/navigation_routes";
import {NAVIGATION_CATEGORY, NAVIGATION_SERVICE} from "~/constants/navigation/services";
import {CITY_SIGN} from "~/constants/values/default_values";
import {META_DESC_PHONE} from "~/constants/values/contacts";
const { t } = useI18n();

const data = {
  title: 'Поддерживающая уборка помещений от 12000 тг',
  // description: 'Предлагаем профессиональную уборку квартир и домов в районе метро Жибек жолы. Оперативный выезд, профессиональные клинеры.',
  metaDescription: `Поддерживающая уборка помещений в ${CITY_SIGN} недорого. ✔ Профессиональное оборудование! ✔ Индивидуальные условия! ✔ Клининговая компания №1 в Казахстане. ✆ Звоните ${META_DESC_PHONE}!`,
  lowPrice: '12000',
  breadcrumbs: [
    {
      url: NAVIGATE_HOME,
      navigateTo: NAVIGATE_HOME,
      title: t('b2b_landing.b2b_page_title'),
      isHome: true
    },
    {
      url: '/podderzhivayuschaya-uborka-pomescheniy',
      navigateTo: '/podderzhivayuschaya-uborka-pomescheniy',
      title: 'Поддерживающая уборка помещений',
    }
  ],
  reviews: [
    {
      name: 'Айгерим Ильясова',
      rating: {
        text: '5.0',
        value: '5'
      },
      text: 'Такой качественной уборки у меня еще не было. Ребята находили грязь в таких местах, о которых я даже представить себе не могла. Однозначно рекомендую!'
    },
    {
      name: 'Рашида Кабдрашева',
      rating: {
        text: '5.0',
        value: '5'
      },
      text: 'Спасибо за качественное обслуживание! Квартира была тщательно убрана в удобное для меня время и по очень приятной цене.Ваши услуги не стыдно рекомендовать знакомым и друзьям.Желаю удачи в бизнесе!'
    },
  ],
  navigateToOrder: NAVIGATION_SERVICE.replace(':service', 'standartnaya-uborka')
}

const links = [
  {
    title: 'Поддерживающая уборка квартир',
    description: 'Для поддержания чистоты после генеральной уборки',
    navigateTo: '/podderzhivayuschaya-uborka-kvartir',
    price: '12000',
    onOrderNavigate: NAVIGATION_SERVICE.replace(':service', 'standartnaya-uborka')
  },
  {
    title: 'Поддерживающая уборка дома',
    description: 'Для поддержания чистоты после генеральной уборки',
    navigateTo: '/podderzhivayuschaya-uborka-doma',
    price: '18000',
    onOrderNavigate: NAVIGATION_SERVICE.replace(':service', 'standartnaya-uborka')
  },
  {
    title: 'Поддерживающая уборка коттеджа',
    description: 'Для поддержания чистоты после генеральной уборки',
    navigateTo: '/podderzhivayuschaya-uborka-kottedzha',
    price: '18000',
    onOrderNavigate: NAVIGATION_SERVICE.replace(':service', 'standartnaya-uborka')
  },
  {
    title: 'Поддерживающая уборка офисов',
    description: 'Поддерживающая уборка офисов',
    navigateTo: '/podderzhivayuschaya-uborka-ofisov',
    price: '40000',
    onOrderNavigate: NAVIGATION_SERVICE.replace(':service', 'standartnaya-uborka')
  },
]
</script>

<template>
  <WidgetOldPageService :document-title="`Поддерживающая уборка помещений в ${CITY_SIGN}, цена`" :pageData="data" :show-diff="false" :links="links"/>
  <section class="line line_white"><div class="section template-content clearfix"><p>В целях эстетичности, комфорта и для здоровья важно поддерживать чистоту в доме и на рабочем месте. Поддерживающая уборка помещений производится каждый день или несколько раз в неделю, в зависимости от различных факторов.</p>
    <p>Из широкого спектра услуг сервиса ТОР.kz можно заказать стандартный поддерживающий клининг помещений. Данная услуга реализуется разово или регулярно в указанное время и включает: уборку локальных загрязнений, протирание пыли с доступных поверхностей, вынос мусора и т.д. (подробнее виды работ указаны в специальном блоке).</p>
    <h2>Заказ поддерживающей уборки в ТОР.kz позволит вам:</h2>
    <ol>
      <li>Оценить удобство и возможности нашего сервиса. Учитывая ваши индивидуальные пожелания, мы предлагаем выгодную стоимость только за обозначенный фронт работ.</li>
      <li>Получить качественные услуги. У нас работают профессиональные клинеры, которые компетентны в вопросах уборки, используют качественные безопасные средства, имеют опыт работы с различными декоративными покрытиями, мебелью, техникой и т.д.</li>
      <li>Экономить бюджет. На рынке профессионального клининга мы предлагаем лучшее соотношение цены и качества. Цена может быть еще доступнее, если воспользоваться специальными предложениями и акциями от компании.</li>
      <li>&nbsp;Проявить доверие. Компания ТОР самостоятельно несет ответственность и материальные гарантии за имущество клиентов (страхование на 5 млн. тенге) при каждом заказе уборки.</li>
      <li> Получить удовольствие от заказа. Чтобы вам нравилось с нами сотрудничать, мы неустанно развиваемся и стараемся предлагать самое лучшее, от консультирования до безупречной чистоты помещений и объектов.</li>
    </ol>
    <p>Сайт позволяет самостоятельно сделать заказ услуги поддерживающей уборки, но нам также будет приятно с вами связаться по телефону или при встрече.</p>
  </div></section>
</template>

<style scoped>
@import "@/assets/css/old-website/style.css";
</style>